<template>
  <div class="g-container-box">
    <el-row class="g-header-container">
      <el-col :span="3">
        <div class="g-header-left">熟客控制台</div>
      </el-col>
      <el-col :span="16">
        <nav-head navSel="2"></nav-head>
      </el-col>
      <el-col :span="5">
        <op-head></op-head>
      </el-col>
    </el-row>

    <el-row class="g-view-container">
      <el-col :span="3" class="g-menu-container">
        <sidebar defaultSel="3"></sidebar>
      </el-col>

      <el-col :span="21" class="g-center-container">
        <div class="page-card">
          <div class="page-head">
            <div>
              <div class="page-title">申请审核列表</div>
              <div class="page-desc">查看申请记录，并对待审核申请进行处理</div>
            </div>
          </div>

          <div class="table-card">
            <el-table
              :data="listData"
              border
              stripe
              v-loading="tableLoading"
              class="custom-table"
              header-cell-class-name="table-header-cell"
              empty-text="暂无申请数据"
            >
              <el-table-column prop="applyTime" label="申请时间" min-width="180"></el-table-column>
              <el-table-column prop="salesManager" label="管理员" min-width="140"></el-table-column>
              <el-table-column prop="applicant" label="申请人姓名" min-width="140"></el-table-column>
              <el-table-column prop="mobile" label="电话" min-width="160"></el-table-column>

              <el-table-column label="状态" width="120" align="center">
                <template slot-scope="scope">
                  <span
                    :class="[
                      'status-pill',
                      scope.row.applyStatus == 2 ? 'ok' : '',
                      scope.row.applyStatus == 3 ? 'reject' : '',
                      scope.row.applyStatus == 1 ? 'pending' : ''
                    ]"
                  >
                    {{ getApplyStatusName(scope.row.applyStatus) }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="140" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    v-if="isPending(scope.row.applyStatus)"
                    type="text"
                    class="audit-btn"
                    @click="openAudit(scope.row)"
                  >
                    审核
                  </el-button>

                  <span
                    v-else
                    :class="[
                      'done-text',
                      scope.row.applyStatus == 3 ? 'reject' : ''
                    ]"
                  >
                    {{ getApplyStatusName(scope.row.applyStatus) }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <el-dialog
          title="审核"
          :visible.sync="auditDialogVisible"
          width="460px"
          :close-on-click-modal="false"
          class="audit-dialog"
        >
          <div class="audit-box">
            <div class="audit-tip">请选择本次审核处理方式：</div>

            <el-radio-group v-model="auditAction" class="audit-group">
              <!-- <label class="audit-option">
                <el-radio :label="1">通过申请</el-radio>
              </label> -->

              <label class="audit-option">
                <el-radio :label="2">拒绝申请</el-radio>
              </label>

              <label class="audit-option">
                <el-radio :label="3">直接赋予权限</el-radio>
              </label>
            </el-radio-group>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button @click="auditDialogVisible = false">取消</el-button>
            <el-button
              type="primary"
              :loading="auditSubmitting"
              @click="submitAudit"
            >
              确定
            </el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var util = require("@/common/util.js");
import { API_TZSQLIST, API_TZSQSPZH } from "../../assets/js/api.js";

import sidebar from "../../components/sidebar.vue";
import navHead from "../../components/navHead.vue";
import opHead from "../../components/opHead.vue";

export default {
  name: "applyAuditPage",
  components: {
    sidebar,
    navHead,
    opHead
  },

  data() {
    return {
      listData: [],
      tableLoading: false,

      // 审核弹窗
      auditDialogVisible: false,
      auditAction: 1, // 1通过 2拒绝 3直接赋权
      auditRow: null,
      auditSubmitting: false
    };
  },

  created() {
    this.getListData();
  },

  methods: {
    // 列表
    getListData() {
      this.tableLoading = true;

      util.postData(
        API_TZSQLIST,
        {},
        (res) => {
          this.listData = res && res.data && res.data.data ? res.data.data : [];
          this.tableLoading = false;
        },
        "application/json"
      );
    },

    // 仅用于显示：applyStatus=1 才算待审核
    isPending(applyStatus) {
      return applyStatus === 1;
    },

    // 状态文案
    getApplyStatusName(applyStatus) {
      if (applyStatus === 1) return "待审核";
      if (applyStatus === 2) return "已通过";
      if (applyStatus === 3) return "已拒绝";
      return "未知状态";
    },

    // 打开审核弹窗
    openAudit(row) {
      this.auditRow = row;
      this.auditAction = 1;
      this.auditDialogVisible = true;
    },

    // 提交审核
    submitAudit() {
      if (!this.auditRow) return;

      const id = this.auditRow.id;
      const params = {
        id,
        auditStatus: this.auditAction
      };

      this.auditSubmitting = true;

      util.postData(
        API_TZSQSPZH,
        params,
        (res) => {
          this.auditSubmitting = false;
          this.auditDialogVisible = false;
          this.$message.success("操作成功");
          this.getListData();
        },
        (err) => {
          this.auditSubmitting = false;
          this.$message.error("操作失败");
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.g-container-box {
  overflow: hidden;
  background: #f5f7fa;
}

.g-header-left {
  background-color: #5c6be8;
  color: #fff;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}

.g-menu-container {
  height: calc(100vh - 60px);
  background-color: #fff;
  border-right: 1px solid #ebeef5;
}

.g-center-container {
  overflow: auto;
  height: calc(100vh - 60px);
  background-color: #eff3f6;
  padding: 20px;
  box-sizing: border-box;
}

.page-card {
  min-height: 100%;
}

.page-head {
  margin-bottom: 16px;
  padding: 20px 24px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  line-height: 28px;
}

.page-desc {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
}

.table-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.custom-table {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.custom-table /deep/ .table-header-cell {
  background: #f7f9fc !important;
  color: #606266;
  font-weight: 600;
}

.custom-table /deep/ .el-table td,
.custom-table /deep/ .el-table th {
  padding: 14px 0;
}

.custom-table /deep/ .el-table__row td {
  color: #606266;
}

.status-pill {
  display: inline-block;
  min-width: 68px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #606266;
  background: #f2f6fc;
}

.status-pill.pending {
  color: #e6a23c;
  background: rgba(230, 162, 60, 0.12);
}

.status-pill.ok {
  color: #67c23a;
  background: rgba(103, 194, 58, 0.12);
}

.status-pill.reject {
  color: #f56c6c;
  background: rgba(245, 108, 108, 0.12);
}

.audit-btn {
  font-weight: 500;
  color: #409eff;
}

.audit-btn:hover {
  color: #66b1ff;
}

.done-text {
  font-size: 13px;
  color: #67c23a;
  font-weight: 500;
}

.done-text.reject {
  color: #f56c6c;
}

.audit-dialog /deep/ .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.audit-dialog /deep/ .el-dialog__header {
  padding: 18px 20px;
  border-bottom: 1px solid #ebeef5;
}

.audit-dialog /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.audit-dialog /deep/ .el-dialog__body {
  padding: 22px 24px 10px;
}

.audit-box {
  padding: 0;
}

.audit-tip {
  margin-bottom: 16px;
  font-size: 14px;
  color: #606266;
}

.audit-group {
  display: block;
}

.audit-option {
  display: block;
  padding: 14px 16px;
  margin-bottom: 12px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fafbfd;
  cursor: pointer;
  transition: all 0.2s ease;
}

.audit-option:hover {
  border-color: #c6e2ff;
  background: #f5faff;
}

.audit-option:last-child {
  margin-bottom: 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1400px) {
  .g-center-container {
    padding: 16px;
  }

  .page-head {
    padding: 16px 18px;
  }

  .table-card {
    padding: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/dlsOne/index.vue